module.exports = __webpack_public_path__ + "img/calendar.c1757222.svg";